import React from 'react';
import { useTranslation } from 'react-i18next';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import SubmissionDetails from '../../../SubmissionDetails';
import Stats from '../../../Stats';
import { useScrollToDeviationComments } from '../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import JournalTags from '../../Details/_partials/JournalTags';
import Benefit from '../../TierProductCardDumb/Benefit';
import { getTierDescription } from '../../_helpers';
import s from './Tier.scss';
const TierContent = ({ deviation, deviation: { extended: { tags } = {}, tier: { benefits = [], discord } = {} }, withArtist = true })=>{
    var _discord;
    const { t } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const scrollToDeviationComments = useScrollToDeviationComments();
    const hasDiscord = (_discord = discord) === null || _discord === void 0 ? void 0 : _discord.connected;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, withArtist && /*#__PURE__*/ React.createElement("div", {
        className: s['author-block']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['stats']
    }, /*#__PURE__*/ React.createElement(Stats, {
        deviation: deviation,
        withSubscriberCount: true,
        withViewCount: false,
        withBadges: false,
        onCommentClick: scrollToDeviationComments
    })), tags && /*#__PURE__*/ React.createElement(JournalTags, {
        tags: tags
    }), isExtendedLoaded && /*#__PURE__*/ React.createElement("div", {
        className: s['text-content']
    }, /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, getTierDescription(deviation)), /*#__PURE__*/ React.createElement("ul", {
        className: s['benefits']
    }, hasDiscord && /*#__PURE__*/ React.createElement(Benefit, {
        benefit: t('deviationview.tierCard.benefits.discord'),
        isDiscord: true,
        className: s['benefit']
    }), benefits.map((benefit)=>/*#__PURE__*/ React.createElement(Benefit, {
            key: benefit,
            benefit: benefit,
            className: s['benefit']
        })))));
};
TierContent.displayName = 'TierContent';
export default TierContent;
